import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`

    .spinner-block {
        position: relative;
        z-index: 96;
    }

    .spinner-block__inner {
        pointer-events: none;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;

        &.spinner-block__inner--loading {
            pointer-events: none;
            background-color: rgba(255,255,255, 0.5)
        }
    }

    .spinner-block__spinner {
        position: absolute;
        top: 200px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        z-index: 100;
    }

`;

